import { render, staticRenderFns } from "./MotivoAgregacaoForm.vue?vue&type=template&id=5d5b3f70"
import script from "./MotivoAgregacaoForm.vue?vue&type=script&lang=js"
export * from "./MotivoAgregacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports